import DoctorModal from '../StepChooseInfo/DoctorModal';
import SpecialtyModal from './SpecialtyModal';

export const getSheetMethodContentMap = (props: any) => ({
  specialty: <SpecialtyModal {...props} />,
  doctor: <DoctorModal {...props} />,
});
